import { Button } from "ui/components/button";

export function FilterActions({ applyFilters, clearLocalFilters }) {
  return (
    <div className="flex place-self-end gap-4">
      <Button variant="outline" onClick={clearLocalFilters}>
        Clear
      </Button>
      <Button onClick={applyFilters}>Apply</Button>
    </div>
  );
}

export default FilterActions;
